import { createFileRoute } from '@tanstack/react-router'

import { TrackingHub } from '@/components/tracking/tracking-hub'

export const Route = createFileRoute('/_app/_authed/_sidebar/tracking')({
    // ?vehicle=<id> pre-selects a vehicle — used by the order detail
    // "Xem camera/GPS" deep link. The old ?tab param is gone: the screen is no
    // longer split into tabs, and unknown params are simply dropped.
    validateSearch: (
        search: Record<string, unknown>,
    ): { vehicle?: string } => ({
        vehicle:
            typeof search.vehicle === 'string' && search.vehicle !== ''
                ? search.vehicle
                : undefined,
    }),
    component: TrackingPage,
})

function TrackingPage() {
    const { vehicle: focusVehicleId } = Route.useSearch()
    return <TrackingHub focusVehicleId={focusVehicleId} />
}
